// localStorage

export const LocalStorageKeys = {
  ACCESS: "access",
  REFRESH: "refresh",
  PLAN_START_DATE: "startDate",
  PLAN_END_DATE: "endDate",
};
